import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import {
  IBasketItem,
  IUnsavedBasketItem,
} from "../../Purchasing/services/baskets";
import { loadBasketPaymentMethodNames } from "../services/paymentMethods";
import { PaymentMethodType } from "../types";

type IUseAvailablePaymentMethodsProps = {
  resourceType: "basket";
  resourceAttributes: {
    id: string;
    items: (IBasketItem | IUnsavedBasketItem)[];
  };
};

export const useAvailablePaymentMethods = ({
  resourceType,
  resourceAttributes,
}: IUseAvailablePaymentMethodsProps) => {
  const { data, isLoading } = useDataQuery(
    ["availablePaymentMethods", resourceType, resourceAttributes],
    () => {
      if (resourceType === "basket") {
        return loadBasketPaymentMethodNames(resourceAttributes);
      }
    },
    {
      enabled: !!resourceAttributes?.id,
    }
  );

  const defaultMethod: PaymentMethodType | undefined = data?.find(
    (m) => m.enabled === true && m.allowed === true
  )?.name;

  const allowedPaymentMethods =
    data?.filter((m) => m.allowed === true).map((m) => m.name) || [];

  const enabledPaymentMethods =
    data
      ?.filter((m) => m.allowed === true && m.enabled === true)
      .map((m) => m.name) || [];

  return {
    defaultMethod,
    allowedPaymentMethods,
    enabledPaymentMethods,
    isLoading,
  };
};
